import { checkIsErrorToolOutput } from "@repo/app-types/agents/errorToolOutput";
import type {
  GetCoachingNotesToolInput,
  GetCoachingNotesToolOutput,
} from "@repo/app-types/entities/copilot";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";
import { DateTime } from "luxon";

export const GetCoachingNotesTool: ToolComponent<
  GetCoachingNotesToolInput,
  GetCoachingNotesToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Retrieving coaching notes...";
    }

    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while retrieving coaching notes";
    }

    const coachingNotes = props.output.coaching_notes;

    if (!coachingNotes) {
      return "No coaching notes found";
    }

    const fromDate = DateTime.fromISO(coachingNotes.date_range.from);
    const toDate = DateTime.fromISO(coachingNotes.date_range.to);
    const dateRange = `${fromDate.toFormat("MMM d")} – ${toDate.toFormat("MMM d")}`;

    return `Retrieved coaching notes for ${dateRange}`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
